export default __webpack_public_path__ + "static/media/DownloadFromCloudBlack.1e458867.svg";